import { Challenge } from 'src/models/Challenge';
import { Session } from 'src/components';
import { ChallengesService } from 'src/services';

const PracticePlanDetails: React.FC<Challenge> = (
  practicePlan,
) => (
  <Session
    contentType={practicePlan.contentType}
    title={practicePlan.title}
    underline={practicePlan.underline}
    difficulty={practicePlan.difficulty}
    primaryDescription={practicePlan.primaryDescription}
    secondaryDescription={practicePlan.secondaryDescription}
    coach={practicePlan.coach}
    tag={practicePlan.tag as any}
    equipment={practicePlan.equipment as any}
    video={practicePlan.video}
    attachments={practicePlan.extras}
    horizontalThumbnail={practicePlan.horizontalThumbnail}
    duration={practicePlan.duration}
    isLiked={practicePlan.isLiked}
    toggleLike={liked => ChallengesService.toggleChallengeLiked(practicePlan.id, liked)}
  />
);

export default PracticePlanDetails;
